/*
 * Copyright (c) 2025 Ipivot Corporation.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 *  Ipivot Corporation ("Confidential Information").
 */
'use strict'

import { useParams } from "react-router-dom";
import FingerEdit from './FingerEdit';

function FingerprintPage() {
    let { fid } = useParams();

    // In the top page we are in a Row that covers the main bottom part of the page,
    //    this is set to not scroll
    return (
      <FingerEdit fid={fid} />
    );
}

export default FingerprintPage;